import axios from "axios";
import { notify } from "./Toast";
import { queueRequest } from "../../offline/outbox";
import ApiService from "../../Service/ApiService";

// Create an Axios instance (optional, but recommended for better control)
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASEURL, // Change to your base URL
  timeout: 10000,
});

// Request Interceptor
axiosInstance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    // Example: Add an Authorization token
    if (token) config.headers.Authorization = `Bearer ${token}`;

    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    notify(error.message, "error");
    return error;
  }
);

// Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    const apiResponse = response.data;
    const isWrappedResponse =
      apiResponse &&
      typeof apiResponse === "object" &&
      ("statusCode" in apiResponse || "success" in apiResponse);

    if (isWrappedResponse) {
      const isSuccessResponse =
        (typeof apiResponse.statusCode === "number" &&
          apiResponse.statusCode >= 200 &&
          apiResponse.statusCode < 300) ||
        apiResponse.success === true;

      if (!isSuccessResponse) {
        notify(apiResponse.message || "Something went wrong", "error");
        return Promise.reject(apiResponse);
      }

      if (apiResponse.message) {
        notify(apiResponse.message, "success");
      }

      return apiResponse.hasOwnProperty("data")
        ? apiResponse.data
        : apiResponse;
    }

    return response;
  },
  (error) => {
    // 🔹 Handle HTTP-level errors (network issues, 500s, etc.)
    let response = error.response;
    if (!response) {
      // Network error or no response received
      notify("Network error. Please check your connection.", "error");
      return Promise.reject(error);
    }
    switch (response.status) {
      case 400:
        notify("Bad Request: " + (response.data?.message || "Invalid input"), "error");
        break;
      case 401:
        notify("Unauthorized: Please log in again.", "error");
        ApiService.logout(); // Clear user data and redirect to login
        window.location.replace("/login");
        break;
      case 403:
        notify("Forbidden: You don't have permission to perform this action.", "error");
        break;
      case 404:
        notify("Not Found: The requested resource was not found.", "error");
        break;
      case 500:
        notify("Server error. Please try again later.", "error");
        break;
      default:
        notify(response.data?.message || "An error occurred. Please try again.", "error");
        break;
    }
    return Promise.reject(error);
  }
);

// Export the configured Axios instance
export default axiosInstance;
